import type { ReportChartFilterItemType } from '../../../../interfaces/report-chart-filter-type';
import type { ReportChartMainFilterKey } from '../../../../interfaces/report-chart-main-filter-key';

export const CatiChart1Filters: ReportChartFilterItemType[] = ['flows', 'channels'];

export const CatiChart1DeactivatedMainFilters: ReportChartMainFilterKey[] = [
  'selectedUnitIds',
  'selectedTagIds',
  'selectedCustomerSchemaIds',
  'selectedCustomerSchemaValues',
];
